import {gettersTypes as companyGettersTypes} from '@/store/modules/company/getters';
import Vue from 'vue';
import {getFullName} from '@/helpers/utils';

export const gettersTypes = {
  isAdmin: '[user] is admin',
  isPlatformAdmin: '[user] is platform admin',
  canUserAdmin: '[user] can user admin',
  canAdminProfile: '[user] can admin profile',
  canImpersonate: '[user] can impersonate',
  companyId: '[user] current company id',
  firstName: '[user] first name',
  lastName: '[user] last name',
  name: '[user] name',
  avatar: '[user] avatar',
  selfTests360: '[user] self tests 360',
  notSelfTests360: '[user] not self tests 360',
  numOfSelfTests360: '[user] number of self tests360',
  numOfNotSelfTests360: '[user] number of not self tests360',
  numOfTests360ForApproval: '[user] number of tests360 for approval',
  accessRights: '[user] access rights',
};

const getters = {
  [gettersTypes.isAdmin]: (state) => {
    if (!state.currentUser) return false;
    return state.currentUser.roles && state.currentUser.roles.indexOf('admin') > -1;
  },
  [gettersTypes.isPlatformAdmin]: (state) => {
    if (!state.currentUser) return false;
    return (
      state.currentUser.roles &&
      state.currentUser.roles.indexOf('platform_admin') > -1 &&
      !Vue.prototype.$sso_master_instance
    );
  },
  [gettersTypes.canUserAdmin]: (state) => {
    // администрация юзеров
    if (!state.platformRights) return false;
    return state.platformRights.users_admin && !Vue.prototype.$sso_master_instance;
  },
  [gettersTypes.canAdminProfile]: (state) => {
    // конструктор профилей
    if (!state.platformRights) return false;
    return state.platformRights.admin_profile;
  },
  [gettersTypes.canImpersonate]: (state) => {
    if (!state.platformRights) return false;
    return state.platformRights.impersonate;
  },
  [gettersTypes.companyId]: (state) => {
    if (!state.currentUser) return 0;
    return state.currentUser.company_id || 0;
  },
  [gettersTypes.firstName]: (state) => {
    if (!state.currentUser) return null;
    return state.currentUser.first_name || null;
  },
  [gettersTypes.lastName]: (state) => {
    if (!state.currentUser) return null;
    return state.currentUser.last_name || null;
  },
  [gettersTypes.name]: (state) => {
    if (!state.currentUser) return null;
    return getFullName(state.currentUser);
  },
  [gettersTypes.avatar]: (state) => {
    if (!state.currentUser) return null;
    return state.currentUser.avatar || null;
  },
  [gettersTypes.selfTests360]: (state) => {
    if (!state.tests360) return null;
    return state.tests360.filter((test) => test.is_selftest);
  },
  [gettersTypes.notSelfTests360]: (state) => {
    if (!state.tests360) return null;
    return state.tests360.filter((test) => !test.is_selftest && !test.closed);
  },
  [gettersTypes.numOfSelfTests360]: (state, getters) => {
    if (!getters[gettersTypes.selfTests360]) return null;
    return getters[gettersTypes.selfTests360].length;
  },
  [gettersTypes.numOfNotSelfTests360]: (state, getters) => {
    if (!getters[gettersTypes.notSelfTests360]) return null;
    return getters[gettersTypes.notSelfTests360].length;
  },
  [gettersTypes.numOfTests360ForApproval]: (state) => {
    if (!state.tests360ForApproval) return null;
    return state.tests360ForApproval.length;
  },
  [gettersTypes.accessRights]: (state, getters) => {
    return getters[companyGettersTypes.isCurrentCompany]
      ? state.currentAccessRights
      : state.accessRights;
  },
};

export default getters;
